export default __webpack_public_path__ + "d1afb413a6ef6274a2544b9b032d8988.svg";